// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDwuvFdUQzxVF50isHaWSbRXEI70fjIpbk",
    authDomain: "tennis-crm.firebaseapp.com",
    databaseURL: "https://tennis-crm.firebaseio.com",
    projectId: "tennis-crm",
    storageBucket: "tennis-crm.appspot.com",
    messagingSenderId: "694835125509",
    appId: "1:694835125509:web:e0ac7fea2b6e48ffb02b6c",
    measurementId: "G-DELBEL675S"
  },
  mainName: 'Громадська організація "Теніс-Мікс"',
  subtitleHeader: 'Грає вся сім\'я'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
